<template>
    <div class="marker">

        <div>
            <img src="/images/markers/marker-active.svg" width="20" height="20">
        </div>

        <div class="marker-content">
            <h2>{{ truck.name }}</h2>

            <div class="driver" v-if="(truck.driver || truck.driverDetails && truck.driverDetails[0])">
                <span><i class="fa-regular fa-id-card"></i></span>
                <span v-if="truck.driver.name">{{ truck.driver.name }} {{ truck.driver.lastname ? truck.driver.lastname : '' }}</span>
                <span v-else-if="truck.driverDetails && truck.driverDetails[0]">{{ truck.driverDetails[0].name }} {{ truck.driverDetails[0].lastname ? truck.driverDetails[0].lastname : '' }}</span>
            </div>

            <div class="location" v-if="stats && stats.gps">
                <div class="address">{{ stats.gps.address }}</div>
                <div class="time">{{ locationDate }}</div>
            </div>

        </div>
    </div>
</template>

<script>
import moment from 'moment';

    export default {
        props: ['truck', 'stats'],
        computed: {
            locationDate() {
                if(this.stats && this.stats.gps) {
                    let date = moment(this.stats.gps.time);
                    return date.format('MMM D YYYY HH:mm');
                }
                return null;
            }
        }
    }
</script>

<style lang="scss" scoped>

.location {
    display: grid;
    row-gap: 5px;
    .address {
        font-size: 13px;
    }
    .time {
        font-size: 12px;
        opacity: 0.75;
    }
}

.driver {
    display: flex;
    gap: 10px;
    align-items: center;
    font-size: 14px;
    color: $buttonColor;
}

.marker {
    position: relative;
    cursor: pointer;
    transform: translateY(50%);
    

    .marker-content {
        position: absolute;
        bottom: 100%;
        left: 50%;
        transform: translate(-50%, -20px);
        background: #fff;
        padding: 20px;
        border-radius: 10px;
        width: 320px;
        opacity: 0;
        pointer-events: none;
        display: grid;
        row-gap: 10px;
    }

    &.shown {
        z-index: 5;
        .marker-content {
            pointer-events: auto;
            opacity: 1;
        }
    }

}

</style>